<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <div class="cont_box mt-2">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
       <el-tab-pane label="排课类型与学习班信息" name="0">
          <SchedulingTypePanel
            ref="SchedulingCoursePanel"
          ></SchedulingTypePanel>
        </el-tab-pane>
        <el-tab-pane label="配置课程信息" name="1">
          <SchedulingCoursePanel
            ref="SchedulingCoursePanel"
          ></SchedulingCoursePanel>
        </el-tab-pane>
        <el-tab-pane label="修改日期和地点" name="2">
          <SchedulingLocationAndDatePanel ref="schelocationref"></SchedulingLocationAndDatePanel>
        </el-tab-pane>
        <el-tab-pane label="修改学时" name="3">
          <SchedulingScorePanel ref="SchedulingScorePanel"></SchedulingScorePanel>          
        </el-tab-pane>
        <el-tab-pane label="修改可见等级" name="4">
          <SchedulingShowLevelPanel ref="SchedulingShowLevelPanel"></SchedulingShowLevelPanel>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import SchedulingTypePanel from "@/views/module/start/comp/SchedulingTypePanel.vue"
import SchedulingShowLevelPanel from "@/views/module/start/comp/SchedulingShowLevelPanel.vue"
import SchedulingCoursePanel from "@/views/module/start/comp/schedulingCoursePanel.vue"
import schedulingStartPanlFour from "@/views/module/start/comp/schedulingStartPanlFour.vue"
import schedulingDetailPreview from "@/views/module/start/comp/components/schedulingDetailPreview.vue"
import SchedulingLocationAndDatePanel from "@/views/module/start/comp/SchedulingLocationAndDatePanel.vue"
import SchedulingScorePanel from "@/views/module/start/comp/SchedulingScorePanel.vue"

export default {
  name: "schedulingEdit",
  components: {
    SchedulingTypePanel,SchedulingShowLevelPanel,SchedulingCoursePanel,schedulingStartPanlFour,schedulingDetailPreview,SchedulingLocationAndDatePanel,SchedulingScorePanel
  },
  data() {
    return {
      activeName : "2",
    }
  },
  methods:{
    initComponent(){
    },

    handleClick(){
      console.log("onTabClick",this.activeName)
      if(this.activeName == "2"){
        console.log("CLICK LOCATION")
        this.$refs.schelocationref?.initDataById();
      }
    },
    initLocationFun(){
      this.$refs.schelocationref?.initDataById();
    }
  },
  
  computed:{
    hasAddressData(){
      return true;
    }
  },
  
  async mounted(){
    let isAdmin = this.$store.getters['profileModule/isadmin'];
    console.log("mounted store isadmin",isAdmin)

    if(this.activeName == "2"){
      console.log("CLICK LOCATION")
      await this.initLocationFun();
    }
  }
};
</script>

<style scoped>
.cont_box {
  background: #fff;
  min-height: 200px;
  padding-bottom: 20px;
}
.item {
  display: flex;
  align-items: center;
}
.subtitle {
  margin-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  font-weight: 500;
}
.block {
  margin: 10px 0;
}
.studyClass {
  font-size: 13px;
  margin-bottom: 25px;
}
</style>